import { Control } from "./control";
import { EventHandler } from "..";

export type TextFieldReceiver<T> = (item: T) => any;

export class ComboBoxChangedEventArgs<T = any> {
    item!: T | null;
    index!: number;
}

export class ComboBox<T = any> extends Control {
    public items: T[] = [];
    public label = "";
    public placeholder = "";
    public help = "";

    public textField: TextFieldReceiver<T> = (item: T) => item;

    public getComponentName(): string {
        return "ComboBoxComponent";
    }

    /** Выделить элемент по условию. */
    public selectBy(predicate: (i: T) => boolean): void {
        const item = this.items.find(predicate);
        this.selectedItem = item ?? null;
    }

    private _selectedItem: T | null = null;
    public get selectedItem(): T | null {
        return this._selectedItem;
    }
    public set selectedItem(item: T | null) {
        if (item === this._selectedItem) {
            return;
        }

        this._selectedItem = item;
        this._selectedIndex = this.items.findIndex(i => i === item);
        this.notifyChangedHandlers();
    }

    private _selectedIndex = -1;
    public get selectedIndex(): number {
        return this._selectedIndex;
    }
    public set selectedIndex(index: number) {
        if (index === this._selectedIndex) {
            return;
        }

        this._selectedIndex = index;
        this._selectedItem = this.items[index];
        this.notifyChangedHandlers();
    }

    private _changedHandlers = new Set<EventHandler<ComboBoxChangedEventArgs<T>>>();
    public addChangedHandler(handler: EventHandler<ComboBoxChangedEventArgs<T>>): void {
        this._changedHandlers.add(handler);
    }
    public removeChangedHandler(handler: EventHandler<ComboBoxChangedEventArgs<T>>): void {
        this._changedHandlers.delete(handler);
    }
    private notifyChangedHandlers(): void {
        const args: ComboBoxChangedEventArgs<T> = {
            item: this._selectedItem,
            index: this._selectedIndex,
        };
        for (const handler of this._changedHandlers) {
            handler(this, args);
        }
    }
}
